import createApiClient from "../lib/createApiClient";
import { apiUrl } from "../config";

const api = createApiClient(apiUrl + "/api/media");

export default api;
